import type { CSSProperties, ReactNode } from 'react'
import type { FichaSectionIcon } from '@escuela/ficha-domain'
import { cn } from '@/lib/utils'

/**
 * Icono de seccion de la ficha. Reusa los mismos PNGs monocromos de la app
 * (copiados a `public/ficha-icons/`), renderizados como mascara CSS tintada con
 * `currentColor` para que adopten el color del texto (theme-aware), igual que el
 * `tintColor` de la app.
 */
export function SectionIcon({
  icon,
  className,
}: {
  icon: FichaSectionIcon
  className?: string
}): ReactNode {
  const url = `url(/ficha-icons/${icon}.png)`
  const style: CSSProperties = {
    maskImage: url,
    WebkitMaskImage: url,
    maskSize: 'contain',
    WebkitMaskSize: 'contain',
    maskRepeat: 'no-repeat',
    WebkitMaskRepeat: 'no-repeat',
    maskPosition: 'center',
    WebkitMaskPosition: 'center',
    backgroundColor: 'currentColor',
  }
  return <span aria-hidden className={cn('inline-block shrink-0', className)} style={style} />
}
